module.exports = __webpack_public_path__ + "img/hr-ccm-universal-04f-blue-LED-off-sequence.a897056a.png";